import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = ({ currentLanguage }) => {
  const badges = {
    fr: [
      {
        icon: 'Shield',
        title: 'Certifié RGPD',
        description: 'Protection des données conforme'
      },
      {
        icon: 'CheckCircle',
        title: 'Agréé Ministère',
        description: 'Tourisme Marocain'
      },
      {
        icon: 'Award',
        title: 'Conformité Islamique',
        description: 'Approuvé autorités saoudiennes'
      }
    ],
    ar: [
      {
        icon: 'Shield',
        title: 'معتمد RGPD',
        description: 'حماية البيانات المتوافقة'
      },
      {
        icon: 'CheckCircle',
        title: 'معتمد من الوزارة',
        description: 'السياحة المغربية'
      },
      {
        icon: 'Award',
        title: 'التوافق الإسلامي',
        description: 'معتمد من السلطات السعودية'
      }
    ]
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {badges?.[currentLanguage]?.map((badge, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center p-4 bg-card/50 rounded-md border border-border"
        >
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Icon name={badge?.icon} size={24} className="text-primary" />
          </div>
          <h4 className="text-sm font-semibold text-foreground mb-1">
            {badge?.title}
          </h4>
          <p className="caption text-muted-foreground">
            {badge?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;